var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { convertButterImageToImageData } from '@marketing/blog/utils';
import { ButtonLink } from '@marketing/components/global/CTA/Button/Button';
import Heading from '@marketing/components/global/typography/Heading';
import Image from '@marketing/components/sections/non_product/Media/Image';
import { useMediaQuery } from '@mui/material';
import { clsx } from 'clsx';
var BlogTile = function (_a) {
    var blogPostData = _a.blogPostData, _b = _a.orientation, orientation = _b === void 0 ? 'vertical' : _b;
    var isMobile = useMediaQuery('(max-width: 768px)');
    var _c = blogPostData.fields, h1 = _c.h1, hero_image = _c.hero_image, summary = _c.summary, slug = blogPostData.slug;
    var containerStyles = {
        vertical: {
            flex: 'flex flex-col justify-start items-center gap-xs-m',
            spacingAndSizing: 'w-full md:w-[328px] p-xs-m',
            image: 'w-full h-[200px]',
            metadata: 'flex flex-col justify-start items-start gap-xs-m',
        },
        horizontal: {
            flex: 'flex flex-row justify-between items-center gap-xl-m',
            spacingAndSizing: 'w-[730px] p-5',
            image: 'w-[200px] h-[200px]',
            metadata: '',
        },
    };
    var metadataStyles = clsx('flex flex-col grow justify-start items-start w-full', orientation === 'vertical' ? 'gap-xs-m' : 'gap-[30px]');
    var imageWidth = orientation === 'horizontal' ? '345px' : '100%';
    var imageHeight = orientation === 'horizontal' ? '218px' : 'auto';
    var aspectRatio = orientation === 'horizontal' || isMobile ? 'auto' : '16 / 9';
    return (_jsxs("div", __assign({ className: clsx('border border-state-inactive-light rounded-md bg-surface-white', containerStyles[orientation].flex, containerStyles[orientation].spacingAndSizing) }, { children: [_jsx(Image, { imageData: convertButterImageToImageData(hero_image), height: imageHeight, width: imageWidth, aspectRatio: aspectRatio, className: "shrink-0" }), _jsxs("div", __assign({ className: metadataStyles }, { children: [_jsx("div", { children: _jsx(Heading, __assign({ size: "sm" }, { children: h1 })) }), orientation === 'vertical' && (_jsx("p", __assign({ className: "grow overflow-hidden text-ellipsis" }, { children: summary }))), _jsx(ButtonLink, __assign({ href: "/learn/article/".concat(slug), className: "w-full mt-auto", size: "large", use: "outline" }, { children: "View Article" }))] }))] })));
};
export default BlogTile;
